'use client';
import { getConsentCookie, isUttEnabled, getUTTCdnUrl } from '@castlery/utils';
import sha256 from 'crypto-js/sha256';
import encHex from 'crypto-js/enc-hex';
import { useEffect } from 'react';
import { useAppSelector } from '@castlery/shared-redux-store';
import { selectedActiveUser } from '@castlery/modules-user-domain';
import { makePersistenceHandles } from '@castlery/shared-persistence-kit';

export const UttIdentifyScript = ({ uttCdnUrl }: { uttCdnUrl: string }) => {
  const user = useAppSelector(selectedActiveUser);

  useEffect(() => {
    const id = 'utt-initial-script';
    const old = document.getElementById(id);
    if (old) old.remove();
    const consentValue = makePersistenceHandles().cookieConsent.getItem() ?? '';
    const emailHashed = user?.email ? encHex.stringify(sha256(user.email)) : '';

    const script = document.createElement('script');
    script.textContent = `(function(a, b, c, d, e, f, g) {e['ire_o'] = c;e[c] = e[c] || function() {(e[c].a = e[c].a || []).push(arguments);};f = d.createElement(b);g = d.getElementsByTagName(b)[0];f.async = 1;f.src = a;g.parentNode.insertBefore(f, g);})('${uttCdnUrl}','script','ire',document,window);ire('consent', 'default', {'tracking': '${
      getConsentCookie('advertisement', consentValue) || 'denied'
    }'});ire('identify', {customerId: '${user?.id ?? ''}',customerEmail: '${emailHashed ?? ''}'});`;
    script.id = id;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      const script = document.getElementById(id);
      if (script) script.remove();
    };
  }, [uttCdnUrl, user]);

  return null;
};

//UttInitialScript
export const UttInitialScript = () => {
  if (!isUttEnabled()) return null;
  const uttCdnUrl = getUTTCdnUrl();
  if (!uttCdnUrl) return null;

  return <UttIdentifyScript uttCdnUrl={uttCdnUrl} />;
};
